import React from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import UnderwriterSupplementalInfo from './UnderwriterSupplementalInfo';

/**
 * Title of a coverage/modifier category header, with its supplemental-info
 * icons.
 *
 * The icons render *inside* the label box rather than as a sibling of it so
 * they sit in the same inline flow as the title text. That keeps them next to
 * the end of the title in every case — a short title, and a long one that
 * wraps onto a second line. As a flex sibling they instead park against the
 * far edge of the column, which reads as detached from a short title.
 */
const SectionHeaderLabel = ({
  title,
  appliedRules,
  warnings,
  referralReasons,
  sx,
}: SectionHeaderLabelProps) => (
  <Box sx={{ minWidth: 0, ...sx }}>
    {title}
    <UnderwriterSupplementalInfo
      appliedRules={appliedRules}
      warnings={warnings}
      referralReasons={referralReasons}
    />
  </Box>
);

export default SectionHeaderLabel;

type SectionHeaderLabelProps = {
  readonly title: React.ReactNode;
  readonly appliedRules?: string[];
  readonly warnings?: string[];
  readonly referralReasons?: string[];
  readonly sx?: SxProps<Theme>;
};
